import React from 'react';

import { SelectBox } from '../../../common/components/SelectBox';
import InputTypes from '../../../common/components/InputTypes';
import { TextArea } from '../../../common/components/TextArea';

interface IProps {
    currencies: string[];
    currency: string;
    message: string;
    creditAmount: string;
    errors: {
        [key: string]: string;
    };
    handleChange(event: React.ChangeEvent<HTMLFormElement>): void;
    handleSelectChange(event: React.ChangeEvent<HTMLFormElement>): void;
    handleBlur(event: React.ChangeEvent<HTMLFormElement>): void;
}

const UserContribution: React.FC<IProps> = ({
    currencies = [],
    currency,
    message,
    creditAmount,
    errors,
    handleChange,
    handleSelectChange,
    handleBlur,
}) => (
        <div className="p-contributionForm">
            <fieldset className="c-form__fieldSet">
                <legend className="c-form__title box-title">Your contribution</legend>
                <div className="p-fieldHalf">
                    <SelectBox
                        name="currency"
                        options={currencies}
                        onChange={handleSelectChange}
                        valueIndex={0}
                        value={currency}
                        placeholder="false"
                        isRequired={true}
                        autocomplete="off"
                    />
                </div>
                <div className="p-fieldHalf">
                    <InputTypes
                        name="creditAmount"
                        label="Credit amount"
                        value={creditAmount}
                        isRequired={true}
                        error={errors.creditAmount}
                        type="number"
                        min="0"
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                </div>
                <TextArea
                    name="message"
                    maxLength={800}
                    rows={5}
                    placeHolder="Message (max 800 characters)"
                    value={message}
                    onChange={handleChange}
                    isRequired={false}
                    label=""
                />
            </fieldset>
        </div>
    );

export default UserContribution;
